<template>
	<div class="member-supply-drop mb-5">
		<img :src="convertToCdnUrl('/img/member/feed_'+dropper+'.gif')" class="dropper hidden-xs" alt="member">
		<img :src="convertToCdnUrl('/img/member/feedpil.svg')" class="dropper-arrow hidden-xs" alt="arrow">
		<div class="drop-info-wrapper">
			<table class="drop-info py-4">
				<tbody v-if="visibleFeedEntries.length">
					<tr v-for="(entry, index) in visibleFeedEntries" :key="index + 'user-log' + entry.id" @click="patchPath(entry.path)">
						<td>{{ getEntryTime(entry.occuredAt) }}</td>
						<td :style="{color: entry.borderColor}">{{ entry.name }}</td>
						<td class="hidden-sm hidden-xs">{{ entry.title }}</td>
					</tr>
					<tr v-if="! visibleFeedEntries.length">
						<td class="text-center">{{ tm('EMPTY_FEED') }}</td>
					</tr>
				</tbody>
				<tbody v-else-if="! visibleFeedEntries.length">
					<tr>
						<td class="text-center">{{ tm('EMPTY_FEED') }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<style scoped>
	td {
		cursor: pointer;
	}
</style>

<script>
import waja from 'waja';
import store from 'datastore';
import { t } from 'datastore/i18n';
import format from 'date-fns/format';
import { convertToCdnUrl, getProductPath, memberRoute} from 'utils';
import svLocale from 'date-fns/locale/sv';
import isSameDay from 'date-fns/is_same_day';

export default {
	store,
	props: ['user'],
	data () {
		return {
			feed: [],
		};
	},
	mounted () {
		waja.get('user/feed?all')
			.on('success', res => {
				this.feed = res.data.entries;
			}).go();
	},
	computed: {
		visibleFeedEntries () {
			return this.feed.slice(0, 4);
		},
		dropper () {
			if (! this.visibleFeedEntries.length) {
				return 'holdt';
			}
			return this.visibleFeedEntries[0].avatarName;
		},
	},
	methods: {
		convertToCdnUrl,
		getEntryTime (timestamp) {
			const today = new Date();
			const date = new Date(timestamp * 1000);
			if (isSameDay(today, date)) {
				return format(date, 'HH:mm');
			}
			return format(date, 'D MMM', {
				locale: svLocale,
			});
		},
		tm: t.prefix('MEMBER'),
		patchPath (path) {
			if (! path) return '';
			const name = path.name;
			const params = path.params || {};
			let route;

			if (name.indexOf('member') === 0) {
				if (params.id === undefined) {
					route = memberRoute(this.user, name);
				}
			}
			if (name.indexOf('product') === 0) {
				route = getProductPath(params.product, null, false);
			}

			return this.$router.push(route);
		},
	},
};
</script>
